import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionBox } from '@/components/SectionBox';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { amlTraceHistorySelectors, profileSelectors } from '@/redux/selectors';
import { amlTraceHistoryActions } from '@/redux/actions';
import TraceInvestigationForm from './components/TraceInvestigationForm/TraceInvestigationForm';
import TraceHistoryList from './components/TraceHistoryList/TraceHistoryList';
import { OnlyForVerifiedSection } from '@/components/OnlyForVerifiedSection/OnlyForVerifiedSection';

import styles from './TraceInvestigation.module.sass';

const TraceInvestigation = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const goToTracer = () => {
    const proHref = (import.meta.env.VITE_REACT_APP_PRO_AMLBOT_URL as string)!;
    window.open(proHref, '_blank');
  };

  const { data: traceHistory } = useAppSelector(
    amlTraceHistorySelectors.getTraceHistorySlice,
  );

  const isAccountLiteMode = useAppSelector(profileSelectors.checkIfModeLimited);

  useEffect(() => {
    if (!traceHistory) {
      dispatch(amlTraceHistoryActions.fetchTraceHistory({}));
    }
  }, [dispatch, traceHistory]);

  return (
    <>
      {isAccountLiteMode && (
        <OnlyForVerifiedSection
          title={t('translation.trace_investigation_limited_title')}
          description={t('translation.trace_investigation_limited_description')}
        />
      )}

      <SectionBox>
        {{
          title: t('translation.ai_investigation_title'),
          body: <TraceInvestigationForm isDisabled={isAccountLiteMode} />,
        }}
      </SectionBox>

      <SectionBox id="trace-history-section">
        {{
          title: t('translation.ai_investigation_history_title'),
          // actions: (
          //   <button
          //     type="button"
          //     className={styles.purchaseProBtn}
          //     onClick={goToTracer}
          //   >
          //     {t('translation.to_edit_purchase_tracer')}
          //   </button>
          // ),
          body: <TraceHistoryList />,
        }}
      </SectionBox>
    </>
  );
};

export default TraceInvestigation;
